"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const types_1 = require("../types");
class BulkDrippingStore {
    constructor() {
        this.currentBulkWizardAction = null;
        this.isActionInProgress = false;
        this.startNewBulkDrippingTime = 0;
        this.startNewAction = () => {
            this.currentBulkWizardAction = types_1.BulkWizardActions.New;
        };
        this.startDeleteAction = () => {
            this.currentBulkWizardAction = types_1.BulkWizardActions.Delete;
        };
        this.getBulkProcessTimeInSeconds = () => {
            return Math.floor((new Date().getTime() - this.startNewBulkDrippingTime) / 1000);
        };
    }
    resetAction() {
        this.currentBulkWizardAction = null;
    }
    setActionInProgress(isActionInProgress) {
        this.isActionInProgress = isActionInProgress;
        this.startNewBulkDrippingTime = new Date().getTime();
    }
}
__decorate([
    mobx_1.observable
], BulkDrippingStore.prototype, "currentBulkWizardAction", void 0);
__decorate([
    mobx_1.observable
], BulkDrippingStore.prototype, "isActionInProgress", void 0);
__decorate([
    mobx_1.action
], BulkDrippingStore.prototype, "startNewAction", void 0);
__decorate([
    mobx_1.action
], BulkDrippingStore.prototype, "startDeleteAction", void 0);
__decorate([
    mobx_1.action
], BulkDrippingStore.prototype, "resetAction", null);
__decorate([
    mobx_1.action
], BulkDrippingStore.prototype, "setActionInProgress", null);
exports.default = new BulkDrippingStore();
